// Storage key for cross-tab logout events — exported so AuthContext can use
// the same constant rather than a duplicated string literal.
export const LOGOUT_EVENT_KEY = 'logout-event';
